import * as tslib_1 from "tslib";
import { m } from '../hyperscript';
import { View } from '../ui/view';
import { Location } from './router';
var Redirect = /** @class */ (function (_super) {
    tslib_1.__extends(Redirect, _super);
    function Redirect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Redirect.prototype.render = function () {
        var to = this.attrs.to;
        return (m(Location, null, function (location) {
            location.replace(location.formatPath(to));
            return null;
        }));
    };
    return Redirect;
}(View));
export { Redirect };
